module.exports = __webpack_public_path__ + "img/2018-3.100d4841.jpg";